module.exports = __webpack_public_path__ + "static/media/homeImage.782edd05.jpg";